//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../no/Section.js";
import "../no/ExpressionCollectorSetList.js";
import "../no/SelectBodyList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.PlateStockBuilder.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/SelectNXObjectList.js";
import "../no/Features.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[1,"CurveBoundary",0,"Section",0],[0,"DistanceTolerance",1,0],[1,"FacePlaneBoundary",0,"ExpressionCollectorSetList",0],[0,"FileName",1,0],[1,"MergeRegions",0,"SelectBodyList",0],[1,"MoldFace",0,"ScCollector",0],[1,"OffsetDistance",0,"Expression",0],[0,"OffsetOption",1,0],[1,"PlateChamferOffsetX",0,"Expression",0],[1,"PlateChamferOffsetY",0,"Expression",0],[0,"PlateHandlingType",1,0],[1,"PlateHoleOffsetX",0,"Expression",0],[1,"PlateHoleOffsetY",0,"Expression",0],[1,"PlateHoleSize",0,"Expression",0],[1,"PlateStock",0,"Features.StructureDesign.PlateStockBuilder",0],[1,"ProjectDirection",0,"GeometricUtilities.ProjectionOptions",0],[0,"RegionPoint",1,0],[1,"Regions",0,"SelectNXObjectList",0]],[[["nRegion"],"CreateRegions",{R_:{regionBodies:"Body[]"}},0,0],[[],"DeleteRegions",{},0,0],[["regionPoint"],"AddRegionPoint",{},1,0],[["regionPoint","bMerge"],"RemoveRegionPoint",{},2,0],[["num_region_points"],"GetMultipleRegionPoints",{R_:{region_points:""}},0,0],[["plateRegionString","regionPoint"],"MapRegionToRegionPoint",{},2,0],[[],"RemoveAllRegionPoints",{},0,0],[["regionPoint"],"AddMergeRegionPoint",{},1,0],[["regionPoint"],"RemoveMergeRegionPoint",{},1,0],[["enabled"],"SetPreviewEnabled",{},1,0],[[],"ClearRegions",{},0,0],[[],"RemoveAllMergedRegionPoints",{},0,0]],[]];
SPLM.Features.StructureDesign.PlateBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.PlateBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.PlateBuilder.OffsetOptions = Object.freeze({
    "All" : "All", "InsideOnly" : "InsideOnly", "OutsideOnly" : "OutsideOnly"});

export default SPLM;